<template>
  <div class="comfort-filter">
    <UiCheckbox
      v-for="item in checkboxItems"
      :key="item.value"
      :label="item.label"
      :isChecked="item.checked"
      class="comfort-filter__checkbox"
      @inputValue="toggleValue(item.value)"
    >
      <template #hint>
        {{ item.description }}
      </template>
    </UiCheckbox>
  </div>
</template>

<script setup lang="ts">
  import { watch, ref } from 'vue';
  import { UiCheckbox } from '@experience/core-checkbox-ui';
  import { getComfortFilterItems } from './consts';
  import { type ComfortValue } from '@/shared/types/basic.ts';
  import type { TTourComfort } from '@/entities/filter/store/types/tour/state';

  interface Props {
    filterItems: ComfortValue[];
  }

  const props = defineProps<Props>();
  const emit = defineEmits<{ (e: 'apply', value: TTourComfort): void }>();

  const { WILD, SIMPLE, STANDARD, PREMIUM } = getComfortFilterItems();

  const comfortItemsList = [WILD, SIMPLE, STANDARD, PREMIUM];

  const checkedValues = ref(new Set(props.filterItems));

  const toggleValue = (value: ComfortValue) => {
    if (checkedValues.value.has(value)) {
      checkedValues.value.delete(value);
    } else {
      checkedValues.value.add(value);
    }
    emit('apply', Array.from(checkedValues.value));
  };

  const checkboxItems = computed(() =>
    comfortItemsList.map((item) => ({
      ...item,
      checked: checkedValues.value.has(item.value),
    })),
  );

  watch(
    () => props.filterItems,
    (newVal) => {
      checkedValues.value = new Set(newVal);
    },
  );
</script>

<style scoped lang="scss">
  .comfort-filter {
    margin-top: 8px;
  }

  .comfort-filter__checkbox {
    grid-template-columns: 20px 1fr;
    width: 100%;
    margin: 8px 0;
  }
</style>
